import { withOidcSecure } from "@axa-fr/react-oidc";
import { useTranslation } from "react-i18next";
import threeDots from "../../../assets/images/Ellipses Large3_dots.png";
import LogokGrey from "../../../assets/images/LogokGrey.png";
import NotificationItem from "../NotificationItem";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  appTheme,
  fetchConfigarationData,
  retrieveData,
} from "../../../helpers/utils/Utils";
import {
  GetApiHeadersWithBearer,
  GetRequest,
  PostRequest,
} from "../../../network/NetworkUtils";
import {
  GET_NOTIFICATIONS,
  NOTIFICATION_READ_ALERTS,
  NOTIFICATION_UNREAD_ALERTS,
  NOTIFICATION_UNREAD_READ_ALERTS,
  STATUS_SUCCESS_CODE,
} from "../../../network/URLConstants";
import Loader from "../../CustomComponents/Loader";
import HomeLayout from "../../Layout/HomeLayout";
import DynamicCard from "../../CustomComponents/DynamicComponent/DynamicCard.js";
import HomeHeader from "../../CustomComponents/HomeHeader";
import { addLineBreaks } from "../../../utils";
import logFirebaseEvents from "../../LogFirebaseEvents/index.js";

const appConfigData = await fetchConfigarationData();

const SMINotifications = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);

  const [notifications, setNotifications] = useState(null);
  const [alerts, setAlerts] = useState(null);
  const [isShowNotificationContent, setIsShowNotificationContent] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState(0);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [isReadAllActive, setIsReadAllActive] = useState(false);
  const [isUnReadAllActive, setIsUnReadAllActive] = useState(false);
  const [userName, setUserName] = useState("");
  const [isFooter, setIsFooter] = useState(true);

  const accessToken = useSelector((state) => state.accessToken);
  const userProfile = useSelector((state) => JSON.parse(state.userProfile));
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const [selectedTab, setSelectedTab] = useState("All");
  const [rowsCountPerPage, setRowsCountPerPage] = useState(8);

  const fetchNotifications = async (
    isRead,
    isUnread,
    isAll,
    tab,
    rowsPerPage
  ) => {
    logFirebaseEvents(
      "Notification",
      "View_More_Notification_Clicked",
      "View_More_Notification_Clicked",
      "",
      ""
    );
    if (cards == null || cards == undefined) {
      return;
    }
    try {
      setIsLoading(true);

      const deviceId = await retrieveData("updatedDeviceId");
      const cardKey =
        cards !== null
          ? cards.find((card) =>
              tab === "Kudzu"
                ? card.AccountTypeBit63 === 64
                : card.AccountTypeBit63 === 1
            ).CardKey
          : 0; //checking cardkey
      const page = 1;

      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const url = GET_NOTIFICATIONS(
        cardKey,
        isRead,
        isUnread,
        rowsPerPage,
        page,
        isAll
      );
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        setAlerts(responseJson.Response.Alerts);
        dispatch({
          type: "UPDATE_NOTIFICATIONS",
          payload: { notifications: responseJson.Response.Alerts.Items },
        });
        setNotifications(responseJson.Response.Alerts.Items);
        setUnreadCounts(responseJson.Response.UnreadCount);
        setIsShowNotificationContent(true);
        if (responseJson.Response.Alerts.TotalItemsCount <= rowsPerPage) {
          setIsFooter(false);
        } else {
          setIsFooter(true);
        }
      }
    } catch (error) {}
  };

  const markAllAsUnreadFun = async () => {
    try {
      setIsLoading(true);
      const AlertIds = notifications.map((notification) => notification.ID);

      const deviceId = await retrieveData("updatedDeviceId");
      const cardKey = cards !== null
      ? cards.find((card) =>
          selectedTab === "Kudzu"
            ? card.AccountTypeBit63 === 64
            : card.AccountTypeBit63 === 1
        ).CardKey
      : 0; //

      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      // const body = {
      //     cardKey: cardKey,
      //     AlertIds: AlertIds,
      // };
      const url = NOTIFICATION_UNREAD_READ_ALERTS(cardKey, false, selectedTab === "All");
      // const url = NOTIFICATION_UNREAD_ALERTS;
      const response = await PostRequest(url, "", headers);
      // const response = await PostRequest(url, body, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        fetchNotifications(true, true, true, "All", rowsCountPerPage);
      }
    } catch (error) {}
  };

  const markAllAsReadFun = async () => {
    try {
      setIsLoading(true);
      // const AlertIds = notifications.map((notification) => notification.ID);

      const deviceId = await retrieveData("updatedDeviceId");
     const cardKey = cards !== null
      ? cards.find((card) =>
          selectedTab === "Kudzu"
            ? card.AccountTypeBit63 === 64
            : card.AccountTypeBit63 === 1
        ).CardKey
      : 0; //

      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      // const body = {
      //     cardKey: cardKey,
      //     AlertIds: AlertIds,
      // };
      // const url = NOTIFICATION_READ_ALERTS;
      const url = NOTIFICATION_UNREAD_READ_ALERTS(cardKey, true, selectedTab === "All");

      const response = await PostRequest(url, "", headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        fetchNotifications(true, true, true, "All", rowsCountPerPage);
      }
    } catch (error) {}
  };

  const handleUnreadClick = () => {
    logFirebaseEvents(
      "Notification",
      "Mark_Unread_Clicked",
      "Mark_Unread_Clicked",
      "",
      ""
    );
    if (notifications !== null || alerts.TotalItemsCount !== 0) {
      setIsUnReadAllActive((prev) => !prev);
      setIsReadAllActive(false);
      if (notifications) {
        markAllAsUnreadFun();
      }
    }
  };

  const handleReadClick = () => {
    logFirebaseEvents(
      "Notification",
      "Mark_Allread_Clicked",
      "Mark_Allread_Clicked",
      "",
      ""
    );
    if (notifications !== null || alerts.TotalItemsCount !== 0) {
      setIsReadAllActive((prev) => !prev);
      setIsUnReadAllActive(false);
      if (notifications) {
        markAllAsReadFun();
      }
    }
  };

  const handleViewMoreClick = () => {
    const totalItemsCount = alerts?.TotalItemsCount || 0;
    const remainingItemCounts = totalItemsCount - rowsCountPerPage;
    let updatedRowCounts;

    if (remainingItemCounts > 8) {
      updatedRowCounts = rowsCountPerPage + 8;
      setRowsCountPerPage(updatedRowCounts);
      setIsFooter(true);
    } else {
      updatedRowCounts = rowsCountPerPage + remainingItemCounts;
      setRowsCountPerPage(updatedRowCounts);
      setIsFooter(false);
    }
    fetchNotifications(
      true,
      true,
      selectedTab === "All",
      selectedTab,
      updatedRowCounts
    );
  };

  useEffect(() => {
    if (userProfile !== undefined && userProfile != null) {
      setUserName(userProfile.FirstName);
    }
    //get read and unread notifications
    fetchNotifications(
      true,
      true,
      selectedTab === "All",
      selectedTab,
      rowsCountPerPage
    );
  }, []);

  const Headingcom = () => {
    return (
      <div className="relative">
        <div className="flex flex-row justify-between mx-10 my-6 md:m-10">
          <div className="flex flex-row gap-2 items-center ">
            <p className="font-hanken-grotesk font-[600] text-[var(--notificationItem-color)] text-[16px] leading-[26px] sm:text-[15px] sm:leading-[23px] md:font-[500] md:text-[26px] md:leading-[36px]">
              {t("notifications")}
            </p>
            {unreadCounts !== 0 && (
              <div
                className="md:h-[40px] md:w-[40px] h-[32px] w-[32px] bg-[var(--unReadNotify-color)]
                            rounded-full flex justify-center items-center"
              >
                <p
                  className="font-hanken-grotesk font-[700] sm:font-[900] 
                                text-[12px] leading-[12px] md:text-[19.2px]
                                 md:leading-[19.2px] text-[var(--unReadNum-color)]"
                >
                  {unreadCounts}
                </p>
              </div>
            )}
          </div>
          <div className="my-auto cursor-pointer">
            <img
              src={appThemeData.threeDots}
              alt="Three Dots"
              onClick={() => setIsShowDropdown((prev) => !prev)}
            />
          </div>
        </div>
        {isShowDropdown && (
          <div className=" absolute right-0 h-[114px] w-[160px] md:w-[185px] z-50 rounded-bl-[1rem]">
            <div className=" flex flex-col cursor-pointer w-full h-full">
              <div
                className={`h-1/2  py-5 px-6 ${
                  notifications === null || alerts.TotalItemsCount === 0
                    ? kudzuPlusTrue
                      ? "opacity-[30%] text-secondary-3 bg-[var(--dropdownDisableBg)]"
                      : "opacity-25 text-secondary-3 bg-[var(--dropdownDisableBg)]"
                    : isUnReadAllActive
                    ? "text-[var(--back-connect-color)] bg-[var(--dropdownBgClick)]"
                    : "text-white  bg-[var(--dropdownBg)] "
                } `}
                onClick={handleUnreadClick}
              >
                <p className="font-hanken-grotesk font-[600] text-[12px] leading-[18px] sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[21px]">
                  {t("mark_all_unread")}
                </p>
              </div>
              <div
                className={` h-1/2  rounded-bl-[1rem] py-5 px-6 ${
                  notifications === null || alerts.TotalItemsCount === 0
                    ? kudzuPlusTrue
                      ? "opacity-[30%] text-secondary-3 bg-[var(--dropdownDisableBg)]"
                      : "opacity-25 text-secondary-3 bg-[var(--dropdownDisableBg)]"
                    : isReadAllActive
                    ? "text-[var(--back-connect-color)] bg-[var(--dropdownBgClick)]"
                    : "text-white  bg-[var(--dropdownBg)] "
                }`}
                onClick={handleReadClick}
              >
                <p className="font-hanken-grotesk font-[600]  text-[12px] leading-[18px] sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[21px]">
                  {t("mark_all_read")}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const children = () => {
    return (
      <>
        {isShowNotificationContent && (
          <div className="flex justify-center sm:mx-0 mx-10">
            <div className="flex flex-col justify-center w-full sm:w-[80%] md:w-[80%] z-0">
              {notifications?.map((notification) => {
                return <NotificationItem notification={notification} />;
              })}
            </div>
          </div>
        )}

        {(notifications === null || alerts.TotalItemsCount === 0) && (
          <div className=" w-full h-[600px] flex flex-col justify-center items-center gap-8 ">
            <div>
              <img src={appThemeData.isLogoKGreyActual} alt="LogokGrey" />
            </div>
            <div className="flex flex-col justify-center items-center ">
              <p className="font-hanken-grotesk font-[500] text-[12px] leading-[18px] lg:text-[18px] lg:leading-[28px] text-[var(--text-UpToDate-clr)] opacity-40">
                {t("no_notification_status1")}
              </p>
              <p className="font-hanken-grotesk font-[500] text-[12px] leading-[18px] lg:text-[18px] lg:leading-[28px] text-[var(--text-UpToDate-clr)] opacity-40">
                {t("no_notification_status2")}
              </p>
            </div>
          </div>
        )}
      </>
    );
  };

  const Footer = () => {
    return (
      <div className=" flex justify-center my-16">
        <p
          className="font-hanken-grotesk font-[600]
                 text-[12px] leading-[20px] md:font-[700] 
                 md:text-[16px] md:leading-[16px] text-[var(--viewMore-clr)]
                  cursor-pointer"
          onClick={handleViewMoreClick}
        >
          {t("viewAll")}
        </p>
      </div>
    );
  };

  const getHeaderText = () => {
    return addLineBreaks(t("notification_heading"));
    // return (`${t('hello_user').replace("{USER}", userName)}\n${t("notification_heading")}`);
  };

  return (
    <HomeLayout>
      <HomeHeader heading={getHeaderText()} isHeaderCaption={true} />
      <div className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight ">
        <DynamicCard
          headerContent={
            <>
              {Headingcom()}
              {/* Tabs */}
              <div className="flex flex-row justify-between items-end bg-white mt-2">
                {["All", "Kudzu", "smiONE"].map((tab) => (
                  <button
                    key={tab}
                    className="flex-1 flex flex-col items-center focus:outline-none px-1"
                    onClick={() => {
                      setSelectedTab(tab);
                      dispatch({
                        type: "Selected_Notification_Tab",
                        payload: { selectedNotificationTab: tab },
                      });
                      fetchNotifications(
                        true,
                        true,
                        tab === "All",
                        tab,
                        8
                      );
                    }}
                    style={{ background: "none", border: "none" }}
                  >
                    <div
                      className={`w-full h-1 rounded-t-full mb-2 transition-all duration-200
                                ${
                                  selectedTab === tab
                                    ? "bg-[#2965FB]"
                                    : "bg-transparent"
                                }
                              `}
                    />
                    <span
                      className={`text-[16px] font-medium transition-colors
                                ${
                                  selectedTab === tab
                                    ? "text-[#2563eb]"
                                    : "text-[#222]"
                                }
                              `}
                    >
                      {tab}
                    </span>
                  </button>
                ))}
              </div>
            </>
          }
          cardHeight="content-fit"
          cardContent={children()}
          footerContent={Footer()}
          isCardFooter={isFooter}
        />
      </div>

      {isLoading && <Loader />}
    </HomeLayout>
  );
};

export default withOidcSecure(SMINotifications);
